import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscriber } from 'rxjs';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-student-sign-photo-upload-popup',
  templateUrl: './student-sign-photo-upload-popup.component.html',
  styleUrls: ['./student-sign-photo-upload-popup.component.scss']
})
export class StudentSignPhotoUploadPopupComponent implements OnInit {
  photoSignDetailsForm: FormGroup;
  croppedImage: SafeUrl = '';
  submitButton = true;
  updateButton = false;
  photoExt: string = 'jpg';
  singExt: string = 'jpg';

  readonly PHOTO_MIN_WIDTH = 200;
  readonly PHOTO_MIN_HEIGHT = 230;
  readonly PHOTO_MAX_WIDTH = 500;
  readonly PHOTO_MAX_HEIGHT = 530;
  readonly PHOTO_MAX_SIZE_KB = 50;

  readonly SIGNATURE_MIN_WIDTH = 140;
  readonly SIGNATURE_MIN_HEIGHT = 60;
  readonly SIGNATURE_MAX_WIDTH = 300;
  readonly SIGNATURE_MAX_HEIGHT = 300;
  readonly SIGNATURE_MAX_SIZE_KB = 20;

  constructor(
    private fb: FormBuilder,
    private dialogRef2: MatDialogRef<StudentSignPhotoUploadPopupComponent>,
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  studentId = sessionStorage.getItem('StudentRGID');

  imageChangedEvent: Event | null = null;
  dialogRef: MatDialogRef<any>;
  userImage: any;
  errormessage: string;
  selectedRgNo: any;
  signatureImage: any;
  userSign: string;
  fileName: string;
  uploadDoc: any;
  proId: any;
  disabled = false;
  tabs: string;
  displayName: any;
  Course: any;
  College: any;
  isSaving: boolean = false;
  hideBirthDate: boolean = false;

  photoActualWidth: number = 0;
  photoActualHeight: number = 0;
  signatureActualWidth: number = 0;
  signatureActualHeight: number = 0;
  TODAY_DATE = new Date().toISOString().split('T')[0];
  originalPhotoFileName: string = '';
  originalSignatureFileName: string = '';

  genderList: any[] = [];
  filteredGenderList: any[] = [];
  admissionQuotaCategoryList: any[] = [];
  filteredAdmissionQuotaCategoryList: any[] = [];

  // New: District and Tehsil lists (referring to District Master & Tehasil Master columns)
  districtList: any[] = [];
  filteredDistrictList: any[] = [];
  tehsilList: any[] = [];
  districtTehsilList: any[] = [];          // Tehsils filtered by selected District (base list for mat-select-filter)
  filteredTehsilList: any[] = [];          // Further filtered by search text

  calledApi: number = 0;
  finishedApi: number = 0;

  ngOnInit(): void {
    console.log("Student data:", this.data.key);
    this.selectedRgNo = this.data.selected.StuRgNo;
    this.StudentPersonalId = this.data.selected.StuId;
    this.photoSignDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuRgNo: new FormControl(this.studentId),
      StuPhoto: new FormControl('', Validators.required),
      StuSignature: new FormControl('', Validators.required),
      StuABCId2: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      StuGender: new FormControl('', Validators.required),
      BirthDate: new FormControl('', Validators.required),
      Email: new FormControl('', [Validators.required, Validators.email]),
      MobNo: new FormControl('', [Validators.required]),
      AdharNo: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{12}$')]),
      AdmissionQuotaCategory: new FormControl(''),
      // New: District and Tehsil form controls
      StuDistrict: new FormControl(''),
      StuTehsil: new FormControl('')
    });

    this.fetchGender();
    this.fetchAdmissionQuotaCategory();
    this.fetchDistrictList();      // New
    this.fetchTehsilList();        // New
    this.prepopulation();
    this.getAdditionalDetails();
  }

  isInvalid(controlName: string, errorType: string): boolean {
    const control = this.photoSignDetailsForm.get(controlName);
    return control?.hasError(errorType) && (control?.touched || control?.dirty);
  }

  fetchGender() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchAdmissionQuotaCategory() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.admissionQuotaCategoryList = res.data;
        this.filteredAdmissionQuotaCategoryList = this.admissionQuotaCategoryList.slice();
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  // New: Fetch District List (reusing getDistrict API from DistrictDataComponent)
  fetchDistrictList() {
    const payload = {};
    payload['PageSize'] = 1000;
    payload['PageNumber'] = 1;
    this.umsService.getDistrict(payload).subscribe((res) => {
      if (res && res.data && res.data.length > 0) {
        this.districtList = res.data;
        this.filteredDistrictList = this.districtList.slice();
        // If a district was already pre-populated, re-apply the tehsil filter
        this.applyTehsilFilterByDistrict();
      }
    }, (ERROR: HttpErrorResponse) => {
      // silent — dropdown will just be empty if it fails
    });
  }

  // New: Fetch Tehsil List (reusing getTehasil API from TehasilComponent)
  fetchTehsilList() {
    const payload = {};
    payload['PageSize'] = 9999;
    payload['PageNumber'] = 1;
    this.umsService.getTehasil(payload).subscribe((res) => {
      if (res && res.data && res.data.length > 0) {
        this.tehsilList = res.data;
        this.districtTehsilList = this.tehsilList.slice();
        this.filteredTehsilList = this.districtTehsilList.slice();
        // If a district was already pre-populated, re-apply the tehsil filter
        this.applyTehsilFilterByDistrict();
      }
    }, (ERROR: HttpErrorResponse) => {
      // silent — dropdown will just be empty if it fails
    });
  }

  // New: Called when District dropdown selection changes
  onDistrictChange(event: any) {
    const selectedDsCode = event.value;
    const selectedDistrict = this.districtList.find(d => d.DsCode == selectedDsCode);
    if (selectedDistrict) {
      this.districtTehsilList = this.tehsilList.filter(
        t => t.DsName === selectedDistrict.DsName
      );
    } else {
      this.districtTehsilList = this.tehsilList.slice();
    }
    this.filteredTehsilList = this.districtTehsilList.slice();
    // Reset tehsil selection when district changes
    this.photoSignDetailsForm.get('StuTehsil')?.setValue('');
  }

  // New: Helper to re-apply tehsil filter based on the current district form value
  private applyTehsilFilterByDistrict() {
    const selectedDsCode = this.photoSignDetailsForm?.get('StuDistrict')?.value;
    if (!selectedDsCode || !this.districtList || this.districtList.length === 0 || !this.tehsilList) {
      this.districtTehsilList = (this.tehsilList || []).slice();
      this.filteredTehsilList = this.districtTehsilList.slice();
      return;
    }
    const selectedDistrict = this.districtList.find(d => d.DsCode == selectedDsCode);
    if (selectedDistrict) {
      this.districtTehsilList = this.tehsilList.filter(
        t => t.DsName === selectedDistrict.DsName
      );
    } else {
      this.districtTehsilList = this.tehsilList.slice();
    }
    this.filteredTehsilList = this.districtTehsilList.slice();
  }

  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;
  }

  validateImageDimensions(file: File, type: 'photo' | 'signature'): Promise<{ isValid: boolean; width: number; height: number; message?: string }> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const minWidth = type === 'photo' ? this.PHOTO_MIN_WIDTH : this.SIGNATURE_MIN_WIDTH;
        const minHeight = type === 'photo' ? this.PHOTO_MIN_HEIGHT : this.SIGNATURE_MIN_HEIGHT;
        const maxWidth = type === 'photo' ? this.PHOTO_MAX_WIDTH : this.SIGNATURE_MAX_WIDTH;
        const maxHeight = type === 'photo' ? this.PHOTO_MAX_HEIGHT : this.SIGNATURE_MAX_HEIGHT;
        const maxSizeKB = type === 'photo' ? this.PHOTO_MAX_SIZE_KB : this.SIGNATURE_MAX_SIZE_KB;
        const fileSizeKB = file.size / 1024;

        if (type === 'photo') {
          this.photoActualWidth = img.width;
          this.photoActualHeight = img.height;
        } else {
          this.signatureActualWidth = img.width;
          this.signatureActualHeight = img.height;
        }
        if (fileSizeKB > maxSizeKB) {
          resolve({
            isValid: false,
            width: img.width,
            height: img.height,
            message: `File size exceeds limit. Maximum allowed: ${maxSizeKB}KB. Your file: ${fileSizeKB.toFixed(2)}KB.`
          });
          URL.revokeObjectURL(img.src);
          return;
        }

        const widthInRange = img.width >= minWidth && img.width <= maxWidth;
        const heightInRange = img.height >= minHeight && img.height <= maxHeight;

        const isWidthValid = widthInRange && img.height >= minHeight;
        const isHeightValid = heightInRange && img.width >= minWidth;

        let isValid = false;
        let message = '';

        if (isWidthValid || isHeightValid) {
          isValid = true;
        } else {
          isValid = false;
          if (img.width < minWidth) {
            message = `Width is too small. Minimum required: ${minWidth}px.`;
          } else if (img.width > maxWidth) {
            message = `Width is too large. Maximum allowed: ${maxWidth}px.`;
          } else if (img.height < minHeight) {
            message = `Height is too small. Minimum required: ${minHeight}px.`;
          } else if (img.height > maxHeight) {
            message = `Height is too large. Maximum allowed: ${maxHeight}px.`;
          }
        }

        resolve({
          isValid,
          width: img.width,
          height: img.height,
          message
        });

        URL.revokeObjectURL(img.src);
      };
      img.onerror = () => {
        resolve({ isValid: false, width: 0, height: 0, message: 'Failed to load image' });
        URL.revokeObjectURL(img.src);
      };
      img.src = URL.createObjectURL(file);
    });
  }

  private showErrorDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(() => { });
  }

  private showInfoDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-info-circle'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  onChange1($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.photoExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.photoExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for photo.');
      return;
    }
    this.photoActualWidth = 0;
    this.photoActualHeight = 0;
    this.validateImageDimensions(file, 'photo').then(({ isValid, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase641(file);
    });
  }

  onChangeSign($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.singExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.singExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for signature.');
      return;
    }
    this.signatureActualWidth = 0;
    this.signatureActualHeight = 0;
    this.validateImageDimensions(file, 'signature').then(({ isValid, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase64Sign(file);
    });
  }

  convertToBase641(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile1(file, subscriber);
    });

    observable.subscribe((base64Data: string) => {
      this.userImage = base64Data;
      this.photoSignDetailsForm.get('StuPhoto')?.setValue(base64Data);
      this.photoSignDetailsForm.get('StuPhoto')?.markAsUntouched();
    });
  }

  readFile1(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  convertToBase64Sign(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFileSign(file, subscriber);
    });

    observable.subscribe((base64Data: string) => {
      this.signatureImage = base64Data;
      this.photoSignDetailsForm.get('StuSignature')?.setValue(base64Data);
      this.photoSignDetailsForm.get('StuSignature')?.markAsUntouched();
    });
  }

  readFileSign(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  private getExtensionFromFileName(fileName: string): string {
    if (!fileName) return 'jpg';

    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) return 'jpg';

    const ext = fileName.substring(lastDotIndex + 1).toLowerCase();
    return ext === 'jpeg' ? 'jpg' : ext;
  }

  prepopulation() {
    if (this.data.key == 'view' && this.data.key === 'view') {
      this.updateButton = false;
    } else {
      this.updateButton = true;
    }
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      if (res.status && res.data && res.data.length > 0) {
        const data = res.data[0];
        this.proId = data.StuProfId;
        this.originalPhotoFileName = data.StuPhoto || '';
        this.originalSignatureFileName = data.StuSignature || '';

        if (this.originalPhotoFileName) {
          this.photoExt = this.getExtensionFromFileName(this.originalPhotoFileName);
        }

        if (this.originalSignatureFileName) {
          this.singExt = this.getExtensionFromFileName(this.originalSignatureFileName);
        }
        if (res.status) {
          if ((data.StuPhoto && data.StuPhoto.startsWith('data:')) || data.StuPhoto == null || data.StuSignature == null) {
            this.userImage = data.StuPhoto;
            this.signatureImage = data.StuSignature;

            this.photoSignDetailsForm.patchValue({
              StuPhoto: new FormControl(this.userImage, Validators.required),
              StuSignature: new FormControl(this.signatureImage, Validators.required),
            });
          } else {
            this.getFiles(res.data);
          }
        }
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  getFiles(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['fileNames'] = [data[0].StuPhoto, data[0].StuSignature];
    this.umsService.getFilesDetails(payload).subscribe((res) => {
      this.spinner.hide();
      const files = res.files || [];
      const photoFile = files.find((f: any) =>
        f.fileName?.toLowerCase().includes('photo') || f.fileName?.toLowerCase().includes('stu')
      );
      const signFile = files.find((f: any) =>
        f.fileName?.toLowerCase().includes('sign') || f.fileName?.toLowerCase().includes('signature')
      );

      this.userImage = photoFile?.base64Data || '';
      this.signatureImage = signFile?.base64Data || '';
      if (photoFile?.fileName) {
        this.photoExt = this.getExtensionFromFileName(photoFile.fileName);
      }
      if (signFile?.fileName) {
        this.singExt = this.getExtensionFromFileName(signFile.fileName);
      }
      this.photoSignDetailsForm.patchValue({
        StuPhoto: new FormControl(this.userImage, Validators.required),
        StuSignature: new FormControl(this.signatureImage, Validators.required),
      });
    }, error => {
      this.spinner.hide();
    });
  }

  updateCheck() {
    this.photoSignDetailsForm.markAllAsTouched();
    if (this.photoSignDetailsForm.invalid) {
      let errorMessage = 'Please fill all required fields with valid data.';
      if (this.photoSignDetailsForm.get('StuPhoto')?.invalid) {
        errorMessage = 'Photo is required.';
      } else if (this.photoSignDetailsForm.get('StuSignature')?.invalid) {
        errorMessage = 'Signature is required.';
      } else if (this.photoSignDetailsForm.get('StuABCId2')?.invalid) {
        errorMessage = 'Valid ABC ID is required.';
      } else if (this.photoSignDetailsForm.get('StuGender')?.invalid) {
        errorMessage = 'Gender is required.';
      } else if (this.photoSignDetailsForm.get('BirthDate')?.invalid) {
        errorMessage = 'Valid birth date is required.';
      } else if (this.photoSignDetailsForm.get('Email')?.invalid) {
        errorMessage = 'Valid email is required.';
      } else if (this.photoSignDetailsForm.get('MobNo')?.invalid) {
        errorMessage = 'Valid 10-digit mobile number is required.';
      } else if (this.photoSignDetailsForm.get('AdharNo')?.invalid) {
        errorMessage = 'Valid 12-digit Aadhaar number is required.';
      // } else if (this.photoSignDetailsForm.get('StuDistrict')?.invalid) {
      //   errorMessage = 'District is required.';
      // } else if (this.photoSignDetailsForm.get('StuTehsil')?.invalid) {
      //   errorMessage = 'Tehsil is required.';
      }
      this.showErrorDialog(errorMessage);
      return;
    }
    if (!this.userImage || !this.signatureImage) {
      if (!this.userImage) {
        this.showErrorDialog('Photo is required.');
      }
      if (!this.signatureImage) {
        this.showErrorDialog('Signature is required.');
      }
      return;
    }


    if (!this.photoExt) this.photoExt = 'jpg';
    if (!this.singExt) this.singExt = 'jpg';
    this.isSaving = true;
    this.disabled = true;
    this.spinner.show();
    this.UpdatePhotoSign();
  }

  UpdatePhotoSign() {
    let payload = this.photoSignDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuRgNo = this.selectedRgNo;
    payload.StuPhoto = "photo." + this.photoExt;
    payload.StuSignature = "sign." + this.singExt;
    payload['StuProfId'] = this.proId;
    payload.LoginId = parseInt(sessionStorage.getItem('userId'));
    this.umsService.updatePhotoSignDetails(payload).subscribe(res => {
      if (res.status) {

        this.saveFiles();
      } else {
        this.isSaving = false;
        this.disabled = false;
        this.spinner.hide();
        this.showErrorDialog(res.message || 'Failed to update photo and signature details.');
      }
    }, error => {
      this.isSaving = false;
      this.disabled = false;
      this.spinner.hide();
      this.showErrorDialog('Error updating photo and signature details.');
    });
  }

  submitCheck() {
    this.photoSignDetailsForm.markAllAsTouched();

    if (this.photoSignDetailsForm.invalid) {
      let errorMessage = 'Please fill all required fields with valid data.';

      if (this.photoSignDetailsForm.get('StuPhoto')?.invalid) {
        errorMessage = 'Photo is required.';
      } else if (this.photoSignDetailsForm.get('StuSignature')?.invalid) {
        errorMessage = 'Signature is required.';
      } else if (this.photoSignDetailsForm.get('StuABCId2')?.invalid) {
        errorMessage = 'Valid ABC ID is required.';
      } else if (this.photoSignDetailsForm.get('StuGender')?.invalid) {
        errorMessage = 'Gender is required.';
      } else if (this.photoSignDetailsForm.get('BirthDate')?.invalid) {
        errorMessage = 'Valid birth date is required.';
      } else if (this.photoSignDetailsForm.get('Email')?.invalid) {
        errorMessage = 'Valid email is required.';
      } else if (this.photoSignDetailsForm.get('MobNo')?.invalid) {
        errorMessage = 'Valid 10-digit mobile number is required.';
      } else if (this.photoSignDetailsForm.get('AdharNo')?.invalid) {
        errorMessage = 'Valid 12-digit Aadhaar number is required.';
      // } else if (this.photoSignDetailsForm.get('StuDistrict')?.invalid) {
      //   errorMessage = 'District is required.';
      // } else if (this.photoSignDetailsForm.get('StuTehsil')?.invalid) {
      //   errorMessage = 'Tehsil is required.';
      }

      this.showErrorDialog(errorMessage);
      return;
    }
    if (!this.userImage || !this.signatureImage) {
      if (!this.userImage) {
        this.showErrorDialog('Photo is required.');
      }
      if (!this.signatureImage) {
        this.showErrorDialog('Signature is required.');
      }
      return;
    }
    if (!this.photoExt) this.photoExt = 'jpg';
    if (!this.singExt) this.singExt = 'jpg';
    this.save();
  }

  save() {
    this.isSaving = true;
    this.disabled = true;
    this.spinner.show();
    const payload = this.photoSignDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuRgNo =  this.selectedRgNo;
    payload.StuPhoto = "photo." + this.photoExt;
    payload.StuSignature = "sign." + this.singExt;
    payload.LoginId = parseInt(sessionStorage.getItem('userId'));
    this.umsService.addPhotoSignDetails(payload).subscribe(res => {
      if (res.status) {
        this.saveFiles();
      } else {
        this.isSaving = false;
        this.disabled = false;
        this.spinner.hide();
        this.showErrorDialog(res.message || 'Failed to save details.');
      }
    }, (ERROR: HttpErrorResponse) => {
      this.isSaving = false;
      this.disabled = false;
      this.spinner.hide();
      this.showErrorDialog('Error saving details.');
    });
  }

  saveFiles() {
    if (!this.userImage || !this.signatureImage) {
      this.updateAdditionalDetails();
      return;
    }
    const payload = {
      StuId: parseInt(this.photoSignDetailsForm.value.StuId),
      StuRgNo: this.selectedRgNo,
      files: [
        {
          fileName: "photo." + this.photoExt,
          base64Data: this.userImage
        },
        {
          fileName: "sign." + this.singExt,
          base64Data: this.signatureImage
        }
      ]
    };
    this.umsService.saveFilesDetails(payload).subscribe(
      res => {
        if (res.status) {
          this.updateAdditionalDetails();
        } else {
          console.warn('File save had issues:', res.message);
          this.updateAdditionalDetails();
        }
      },
      (error: HttpErrorResponse) => {
        console.warn('Error saving files:', error.message);
        this.updateAdditionalDetails();
      }
    );
  }

  updateAdditionalDetails() {
    let payload = {
      StuId: parseInt(this.photoSignDetailsForm.value.StuId),
      ABCId: this.photoSignDetailsForm.value.StuABCId2,
      StuGender: this.photoSignDetailsForm.value.StuGender,
      StuNumber: this.photoSignDetailsForm.value.MobNo,
      EmailID: this.photoSignDetailsForm.value.Email,
      StuBirthDate: this.photoSignDetailsForm.value.BirthDate,
      StuAadhar: this.photoSignDetailsForm.value.AdharNo,
      // StuConstiSubCate: this.photoSignDetailsForm.value.AdmissionQuotaCategory,
      StuSocialCate: this.photoSignDetailsForm.value.AdmissionQuotaCategory,
      // New: District and Tehsil values passed in update payload
      StuDistrict: this.photoSignDetailsForm.value.StuDistrict,
      StuTehsil: this.photoSignDetailsForm.value.StuTehsil
    };
    this.umsService.updateABCId(payload).subscribe(res => {
      this.spinner.hide();
      this.isSaving = false;
      this.disabled = false;

      if (res.status) {
        let data = {
          message: res.message || 'All details updated successfully!',
          title: 'Success',
          icon: 'fas fa-check'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef2.close(true);
        });
      } else {
        this.showErrorDialog(res.message || 'Details updated but some information may not have been saved correctly.');
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.isSaving = false;
      this.disabled = false;
      this.showErrorDialog('Error updating additional details.');
    });
  }
private sanitizeDummyData(value: string, type: 'mobile' | 'email' | 'aadhaar'): string {
  if (!value) return value;
  
  if (type === 'mobile' && value.toString().startsWith('T')) {
    return ''; 
  }
  if (type === 'aadhaar' && value.toString().startsWith('T')) {
    return ''; 
  }
  
  if (type === 'email' && value.includes('nomail.com')) {
    return ''; 
  }
  
  return value;
}

  // getAdditionalDetails() {
  //   let payload = {};
  //   payload['StuId'] = parseInt(this.StudentPersonalId);
  //   this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
  //     if (res.status && res.data && res.data.length > 0) {
  //       const studentData = res.data[0];
  //       this.photoSignDetailsForm.patchValue({
  //         StuABCId2: studentData.StuABCId2 || '',
  //         StuGender: studentData.StuGender || '',
  //         BirthDate: studentData.StuBirthDate ?
  //           new Date(studentData.StuBirthDate).toISOString().split('T')[0] : '',
  //         Email: studentData.EmailID || '',
  //         MobNo: studentData.StuNumber || '',
  //         AdharNo: studentData.StuAadhaarNo || '',
  //         AdmissionQuotaCategory: studentData.StuConstiSubCate || ''
  //       });
  //     }
  //   }, (ERROR: HttpErrorResponse) => {
  //     this.spinner.hide();
  //   });
  // }
  getAdditionalDetails() {
  let payload = {};
  payload['StuId'] = parseInt(this.StudentPersonalId);
  this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
    if (res.status && res.data && res.data.length > 0) {
      const studentData = res.data[0];
      const sanitizedMobile = this.sanitizeDummyData(studentData.StuNumber || '', 'mobile');
      const sanitizedEmail = this.sanitizeDummyData(studentData.EmailID || '', 'email');
      const sanitizedAadhaar = this.sanitizeDummyData(studentData.StuAadhaarNo || '', 'aadhaar');
      let birthDateValue = '';
      this.hideBirthDate = false;

      if (studentData.StuBirthDate) {
        const rawDate = studentData.StuBirthDate;
        if (rawDate === '01-01-1950' || rawDate === '1950-01-01') {
          this.hideBirthDate = true;
          birthDateValue = '';       
        } else {
          birthDateValue = new Date(rawDate).toISOString().split('T')[0];
        }
      }

      this.photoSignDetailsForm.patchValue({
        StuABCId2: studentData.StuABCId2 || '',
        StuGender: studentData.StuGender || '',
        BirthDate: birthDateValue,
        Email: sanitizedEmail,
        MobNo: sanitizedMobile,
        AdharNo: sanitizedAadhaar,
        // AdmissionQuotaCategory: studentData.StuConstiSubCate || '',
         AdmissionQuotaCategory: studentData.StuSocialCate || '',
        // New: pre-populate District and Tehsil (fallback field names included)
        StuDistrict: studentData.StuDistrictC || studentData.StuDsCode || '',
        StuTehsil: studentData.StuTehsilC || studentData.StuTsCode || ''
      });

      // New: re-apply tehsil filter based on the pre-populated district
      this.applyTehsilFilterByDistrict();
    }
  }, (ERROR: HttpErrorResponse) => {
    this.spinner.hide();
  });
}
}